import { useBEMClasses } from "@circle-react/hooks/utils/useBEMClasses";
import classnames from "classnames";
import type { ReactNode } from "react";

export interface AvatarContainerProps {
  [key: string]: unknown;
  children?: ReactNode;
  full?: boolean;
  lg?: boolean;
  md?: boolean;
}

export const AvatarContainer = ({
  children,
  ...props
}: AvatarContainerProps) => {
  const blockElement = "skeleton-loader__avatar-container";
  const { modifiers } = useBEMClasses(blockElement, props);

  return <div className={classnames(blockElement, modifiers)}>{children}</div>;
};
